import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

// Fired on window whenever the backend rejects our token. AuthContext listens
// for it and drops the session so the UI reacts immediately.
export const SESSION_EXPIRED_EVENT = "auth:session-expired";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to include auth token in requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// A 401 on any authenticated request means the stored token is no longer
// accepted (expired, user deleted, secret rotated). Clear it and tell the app,
// so the user is sent to the login page instead of seeing a broken save.
// Login/register 401s are ordinary "bad credentials" responses and are left
// alone.
const AUTH_ENDPOINTS = ["/auth/login", "/auth/register"];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const hadToken = !!error.config?.headers?.Authorization;
    const isAuthEndpoint = AUTH_ENDPOINTS.some((p) => url.includes(p));

    if (status === 401 && hadToken && !isAuthEndpoint) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
    }

    return Promise.reject(error);
  },
);

export default api;
